<script>
export default {
  name: 'config',
  /**
   * data
   */
  data () {
    return {
      // local
      BASE_URL: 'http://dev.morecon.jp/'
    }
  },
  /**
   * created
   */
  created () {
    var hostname = window.location.hostname
    if (hostname.indexOf('localhost') !== -1) {
      this.BASE_URL = 'http://dev.morecon.jp/'
      // TODO localhostではdev.morecon.jpのセッションがないので、一度通しておく
    } else {
      this.BASE_URL = window.location.protocol + '//' + hostname + '/'
    }
  },
  methods: {
    buildUrl (path) {
      return this.BASE_URL + path
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/config/Config.vue